import {FunctionComponent, SVGProps} from 'react';

import {Empty} from '_/assets/images';

/**
 * Since we want the same indentation for all items in the dropdown we check
 * if any of the groups of subItems contain an icon. If they do, we assign
 * an empty icon to all items in that subItem group to make sure the texts align.
 *
 * This will become obsolete if a decision is made to only allow dropdowns
 * where all items have an icon or none of them have.
 *
 * Used in the Filter and FilterSelectBox components.
 */
export const fixItemTextMargins = <
  T extends {Icon?: FunctionComponent<SVGProps<SVGSVGElement>>},
>(
  items: T[]
): T[] => {
  if (items.some((e) => 'Icon' in e)) {
    return items.map((subItem) => {
      const editedSubItem = {...subItem};
      if (!('Icon' in editedSubItem)) {
        editedSubItem.Icon = Empty;
      }
      return editedSubItem;
    });
  }
  return items;
};
